<template>
    <div class="variant-group">
      <div
        class="left"
        data-test="variantTemplateValue"
        id="variantTemplateValue"
      >{{value}}</div>
      <div class="right">
        <!--<ul class="variant-list size-wrapper">-->
        <!--<li-->
        <!--v-for="(variant,key,index) in variantCategories"-->
        <!--:key="index"-->
        <!--:index="index"-->
        <!--@click.prevent="variantSwitch(variant[0].product_id)"-->
        <!--:class="variantSelectedClass(variant)?'selected':''"-->
        <!--&gt;-->
        <!--<span :style="variantSelectedClass(variant)?'font-size:.7rem':'opacity: .6;font-size:.7rem'"-->
        <!--:data-test="'variantTemplateKey'+index">-->
        <!--{{key}}-->
        <!--</span>-->
        <!--</li>-->
        <!--</ul>-->
        <!--<select-->
        <!--class="select form-control wp_ProductCategorySelect"-->
        <!--id="document-type-select"-->
        <!--name="documentTypeSelect"-->
        <!--style="text-transform: capitalize;"-->
        <!--data-test="vendorSignUpProofSelect"-->
        <!--v-model="varientKey"-->
        <!--@change="variantSwitch()"-->
        <!--&gt;-->
        <!--<option-->
        <!--v-for="(variant,key,index) in variantCategories"-->
        <!--:value="variant"-->
        <!--:key="key"-->
        <!--:index="index"-->
        <!--:id="'document-upload-'+index"-->
        <!--:data-test="'vendorSignUpProofOptn2'+index"-->
        <!--&gt;-->
        <!--{{key}}-->
        <!--</option>-->
        <!--</select>-->
        <v-select
          :options="varientArray"
          label="name"
          v-model="setVarientCategory"
          @input="variantSwitch"
          transition="fade"
          :clearable="false"
          :searchable="false"
        ></v-select>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'variant-template',
	mounted () {
		for (let [key, value] of Object.entries(this.variantCategories)) {
			this.varientArray.push({
				name: key,
				product_id: value[0].product_id
			})
		}
		this.getSelectedVariantData()
	},
	computed: {
		...mapGetters('productselected', ['getSelectedVariant'])
	},
	watch: {
		$route () {
			this.getSelectedVariantData()
		}
	},
	methods: {
		// variantSwitch (productId) {
		// 	this.$emit('variantSwitching', productId)
		// },
		variantSwitch (evt) {
			this.$emit('variantSwitching', this.setVarientCategory.product_id)
		},
		variantSelectedClass (variant) {
			let products = []
			if (variant && variant[0] && variant[0].product_id) {
				products = variant.findIndex(
					varia => this.getSelectedVariant === varia.product_id
				)
			}
			return products > -1
		},
		getSelectedVariantData () {
			let selectedVariantData = []
			if (this.varientArray.length > 0) {
				selectedVariantData = this.varientArray.filter(variant => {
					return this.getSelectedVariant === variant.product_id
				})
			}
			if (selectedVariantData.length > 0) {
				this.setVarientCategory = selectedVariantData[0]
			} else {
				this.setVarientCategory = {}
			}
		}
	},
	props: {
		variantCategories: null,
		value: null,
		index: {
			default: 0,
			type: Number
		}
	},
	data () {
		return {
			varientKey: '',
			setVarientCategory: '',
			varientArray: []
		}
	}
}
</script>

<style lang="scss">
.vs__dropdown-toggle {
  border-radius: 0;
  border-color: black;
	padding-bottom: 0;
	width: auto;
	min-width: 90px;
}
.vs__actions {
  cursor: pointer;
	padding: 0;
	width: 22px;
	svg{
		height: 100%;
		padding: 8px 0;
	}
}

.vs--open {
  .vs__dropdown-toggle {
    border: solid 1px #adadad !important;
    color: #333;
    background-color: #e6e6e6;
    border-color: #adadad;
    /*box-shadow: inset 0 3px 5px rgba(0,0,0,.125);*/

  }
  .vs__dropdown-menu {
    top: 2.5em;
    border: solid 1px #ccc !important;
			width: auto!important;
			min-width: 1px;
  }
}
.vs--single .vs__selected{
		margin: 0;
		padding: 2.5px 5px;
	font-size: 12px;
	}
	.vs--single.vs--open .vs__selected{
		position: relative!important;
	}
</style>
